import { useEffect, useRef } from 'react'
import { Frequency, FrequencyFetch } from '../types/data'

/**
 * This function can be used anywhere in the app to greet the user
 * @param userName The user's first name
 * @returns A kind greeting message
 */
export const sayHello = (userName: string): string => {
    return `Welcome ${userName}!`
}

export const toCamelCaseKey = (key: string): string => key.replace(/(_\w)|(-\w)/g, (k: string) => k[1].toUpperCase())

export const toCamelCase = (object: any): any => {
    let transformedObject = object
    if (typeof object === 'object' && object !== null) {
        if (object instanceof Array) {
            transformedObject = object.map(toCamelCase)
        } else {
            transformedObject = {}
            Object.keys(object).map((key: any) => {
                if (object[key] !== undefined) {
                    const newKey = toCamelCaseKey(key)
                    transformedObject[newKey] = toCamelCase(object[key])
                }
                return
            })
        }
    }
    return transformedObject
}

export const toSnackCaseKey = (key: string): string =>
    key
        .replace(/\.?([A-Z]+)/g, (_, y: string) => {
            return `_${y.toLowerCase()}`
        })
        .replace(/^_/, '')

export const isCamelCase = (key: string): boolean => /\.?([A-Z]+)/g.test(key)

export const toSnackCase = (object: any): any => {
    let transformedObject = object
    if (typeof object === 'object' && object !== null) {
        if (object instanceof Array) {
            transformedObject = object.map(toSnackCase)
        } else {
            transformedObject = {}
            Object.keys(object).map((key: string) => {
                if (object[key] !== undefined) {
                    const newKey = toSnackCaseKey(key)
                    transformedObject[newKey] = toSnackCase(object[key])
                }
                return
            })
        }
    }
    return transformedObject
}

export const sortArrayPerFrequency = (array: Frequency[]) => {
    return array.sort((a, b) => {
        if (a.frequency < b.frequency) {
            return -1
        }
        if (a.frequency > b.frequency) {
            return 1
        }
        return 0
    })
}

export const convertFrequencyFetched = (freq: FrequencyFetch): Frequency => {
    const frequency: Frequency = {
        id: freq.frequency.id,
        idRadio: freq.frequency.idRadio,
        frequency: parseFloat(freq.frequency.frequency),
        idCity: freq.frequency.idCity,
        city: freq.city,
        radio: freq,
    }
    return frequency
}

/**
 * Mantiene lo stato precendente del valore passato
 * @param value any
 */
export const usePrevious = (value: any): any => {
    const ref = useRef()
    useEffect(() => {
        ref.current = value
    })
    return ref.current
}
